// Page-specific filter configurations for Payment Integrity

import { PIFilterConfig, PIFilterState } from '../types/piFilters.types';
import { getPITimePeriodOptions } from './piFilterOptions';
export const getPIFilterConfig = (): PIFilterConfig => {
  return {
    showTimePeriod: true,
    showTaxId: true,
    showContractIds: true,
    showLineOfBusiness: true,
    showClaimType: true,
    showServiceType: true,
    showVendor: true,
  };
};

export const getPIDefaultFilters = (): PIFilterState => {
  // Build default time period (first entry = current YTD)
  const timeFrames = getPITimePeriodOptions();
  const defaultTimePeriod = timeFrames.length > 0 ? timeFrames[0] : { title: '', value: '', disable: false };

  return {
    timePeriod: defaultTimePeriod,
    taxId: [],
    contractIds: [],
    lineOfBusiness: 'All',
    lineOfBusinessMultiSelect: [],
    claimType: 'All',
    serviceType: 'All',
    vendor: 'All',
  };
};
